import { CheckoutCardSelection } from '#components/molecules/checkout/CheckoutCardSelection/CheckoutCardSelection.js';
import { CheckoutUserInfoForm } from '#components/molecules/checkout/CheckoutUserInfoForm/CheckoutUserInfoForm.js';
import { ApplyRewards } from '#pages/Checkout/ApplyRewards/ApplyRewards.js';
import { CheckoutButton } from '#pages/Checkout/CheckoutButton.js';
import { CheckoutFees } from '#pages/Checkout/CheckoutFees/CheckoutFees.js';
import { CheckoutKeepMeUpdated } from '#pages/Checkout/CheckoutKeepMeUpdated/CheckoutKeepMeUpdated.js';
import { CheckoutReCAPTCHA } from '#pages/Checkout/CheckoutReCAPTCHA/CheckoutReCAPTCHA.js';
import { CheckoutAdditionalFields } from '#pages/Checkout/components/CheckoutAdditionalFields/CheckoutAdditionalFields.js';
import { CheckoutAddressForm } from '#pages/Checkout/components/CheckoutAddressForm/CheckoutAddressForm.js';
import { CheckoutAnonymousDonationForm } from '#pages/Checkout/components/CheckoutAnonymousDonationForm/CheckoutAnonymousDonationForm.js';
import { CheckoutGivingaLegal } from '#pages/Checkout/components/CheckoutGivingaLegal/CheckoutGivingaLegal.js';
import { DiscountSection } from '#pages/Checkout/components/DiscountSection/DiscountSection.js';
import { getStoreItem } from '#pages/Checkout/utils.js';
import { useShowCause } from '@givebacks/api/core';
import { useShowCart } from '@givebacks/api/store';
import { useBreakPoints } from 'core';
import { CheckoutDonationLegal } from 'core/Components';
import { CollapsibleCard, Stack } from 'ui';

import { useCheckoutProvider } from '../checkout-provider/useCheckoutProvider';
import { WithSectionConfig } from './WithSectionConfig';

const CheckoutOrderSection = () => {
  const { checkoutId, onCheckoutSuccess, withCheckoutSuccessNotification } = useCheckoutProvider();

  const { data: storeItem } = useShowCart({
    cartId: checkoutId,
    queryKeyId: 'user',
    select: getStoreItem,
  });
  const { data: cause } = useShowCause(storeItem?.cause_id);

  const { isSmallScreen } = useBreakPoints();

  return (
    <CollapsibleCard headerTitle="Checkout" isCardExpanded={true}>
      <Stack gap={isSmallScreen ? 'md' : 'lg'}>
        <WithSectionConfig configKey="withRewards">
          <ApplyRewards checkoutId={checkoutId} />
        </WithSectionConfig>

        <CheckoutCardSelection />

        <CheckoutUserInfoForm />

        <WithSectionConfig configKey="withAnonymousPurchaseForm">
          <CheckoutAnonymousDonationForm checkoutId={checkoutId} />
        </WithSectionConfig>
        <CheckoutAddressForm checkoutId={checkoutId} />
        <CheckoutAdditionalFields checkoutId={checkoutId} />

        <WithSectionConfig configKey="withDiscountSection">
          <DiscountSection checkoutId={checkoutId} />
        </WithSectionConfig>

        <CheckoutFees checkoutId={checkoutId} />
        <WithSectionConfig configKey="withGivingaLegalSection">
          <CheckoutGivingaLegal checkoutId={checkoutId} />
        </WithSectionConfig>

        <WithSectionConfig configKey="withDonationLegalSection">
          <CheckoutDonationLegal />
        </WithSectionConfig>

        <WithSectionConfig configKey="withKeepMeUpdatedSection">
          <CheckoutKeepMeUpdated causeName={cause?.name} />
        </WithSectionConfig>
        <CheckoutReCAPTCHA />
        <CheckoutButton
          checkoutId={checkoutId}
          onSuccess={onCheckoutSuccess}
          withCheckoutSuccessNotification={withCheckoutSuccessNotification}
        />
      </Stack>
    </CollapsibleCard>
  );
};

export { CheckoutOrderSection };
